import React, { useState, useRef } from "react";
import { Link } from "react-router-dom";
import ReCAPTCHA from "react-google-recaptcha";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./TalepFormu.css";

const TalepFormu = () => {
  const [recaptchaToken, setRecaptchaToken] = useState(null);
  const recaptchaRef = useRef(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.target;

    if (!recaptchaToken) {
      toast.error("Lütfen reCAPTCHA doğrulamasını yapın.");
      return;
    }

    const data = {
      adsoyad: form.adsoyad.value,
      email: form.email.value,
      telefon: form.telefon.value,
      mesaj: form.mesaj.value,
      roller: Array.from(form.querySelectorAll('[name="roller"]:checked')).map(
        (el) => el.value
      ),
      kvkkOnay: form.kvkk?.checked ? "Evet" : "Hayır",
      eticaretOnay: form.onay2?.checked ? "Evet" : "Hayır",
      recaptchaToken,
    };

    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailPattern.test(data.email)) {
      toast.error("Geçerli bir e-posta adresi giriniz.");
      return;
    }

    try {
      const response = await fetch(
        `https://api.airtable.com/v0/${process.env.REACT_APP_AIRTABLE_BASE_ID}/${process.env.REACT_APP_AIRTABLE_TALEP_TABLE_NAME}`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${process.env.REACT_APP_AIRTABLE_TOKEN}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            records: [
              {
                fields: {
                  "Ad Soyad": data.adsoyad,
                  "Email": data.email,
                  "Telefon": data.telefon,
                  "Roller": data.roller.join(", "),
                  "Mesaj": data.mesaj,
                  "E-Ticaret Onay": data.eticaretOnay,
                  "KVKK Onay": data.kvkkOnay,
                  "Tarih": new Date().toISOString(),
                },
              },
            ],
          }),
        }
      );

      if (!response.ok) {
        throw new Error(`Sunucu hatası: ${response.status}`);
      }

      toast.success("Talebiniz alındı.");
      form.reset();
      setRecaptchaToken(null);
      recaptchaRef.current?.reset();
    } catch (err) {
      console.error("Hata:", err);
      toast.error("Sunucu hatası oluştu. Lütfen daha sonra tekrar deneyin.");
    }
  };

  return (
    <>
      <section id="talep-formu" className="talep-form-section">
        <div className="talep-form-container">
          <h2 className="form-title">
            Lingify ile <span>İletişime Geçin</span>
          </h2>
          <p className="form-subtitle">Lingify platformu kullanma talebi ya da sorularınız için formu doldurup bize ulaşabilirsiniz.</p>

          <form className="talep-form" onSubmit={handleSubmit}>
            <label>Ad Soyad</label>
            <input type="text" name="adsoyad" placeholder="Ad Soyad" required />

            <label>Email</label>
            <input type="email" name="email" placeholder="Email" required />

            <label>Telefon</label>
            <input type="tel" name="telefon" placeholder="Telefon" required />

            <p className="form-role-title">Size nasıl hitap edelim?</p>
            <div className="role-pill-group">
              {[
                "Afazi Danışanı",
                "Doktor",
                "Afazi Bakım Veren",
                "Dil ve Konuşma Terapisti",
              ].map((rol) => (
                <label key={rol} className="role-pill">
                  <input type="checkbox" name="roller" value={rol} />
                  <span>{rol}</span>
                </label>
              ))}
            </div>

            <label>Mesajınız</label>
            <textarea
              name="mesaj"
              placeholder="Mesajınız (isteğe bağlı)"
              rows="3"
            />

            <p className="form-role-title">Onaylar</p>

            <label className="checkbox-full">
              <input type="checkbox" name="kvkk" required />
              <span><Link to="/kvkk" target="_blank">KVKK</Link>'yı ve <Link to="/aydinlatma-metni" target="_blank">Aydınlatma Metni</Link>'ni okudum ve anladım.</span>
            </label>

            <label className="checkbox-full">
              <input type="checkbox" name="onay2" />
              <span>Lingify tarafından e-posta/SMS yoluyla ticari elektronik ileti gönderilmesini kabul ediyorum.</span>
            </label>

            <div className="talep-form-recaptcha-container">
              <ReCAPTCHA
                ref={recaptchaRef}
                sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                onChange={(token) => setRecaptchaToken(token)}
                onExpired={() => {
                  setRecaptchaToken(null);
                  toast.warning("reCAPTCHA süresi doldu, lütfen tekrar doğrulayın.");
                }}
                onErrored={() => {
                  setRecaptchaToken(null);
                  toast.error("reCAPTCHA yüklenemedi. Sayfayı yenileyin.");
                }}
              />
            </div>

            <button type="submit" className="submit-button">
              BAŞVUR
            </button>
          </form>
        </div>
      </section>

      <ToastContainer position="bottom-center" autoClose={3000} />
    </>
  );
};

export default TalepFormu;